import { TeamColorKey } from '../../interfaces/database/team.interface';

export const TEAM_COLOR_CLASS: Record<TeamColorKey, string> = {
    blue:    'bg-team-blue',
    indigo:  'bg-team-indigo',
    emerald: 'bg-team-emerald',
    amber:   'bg-team-amber',
    rose:    'bg-team-rose',
    violet:  'bg-team-violet',
};
